// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:20
import { AppSetting_abstract } from './../abstract/SagaBase/AppSetting_abstract';
export class AppSetting extends AppSetting_abstract {
  public constructor(key: string, value: any) {
    super();
    this.Key = key;
    this.Value = value;
  }
}
